import { render, staticRenderFns } from "./LiquidacionesView.vue?vue&type=template&id=2f4c78b5&"
import script from "./LiquidacionesView.vue?vue&type=script&lang=js&"
export * from "./LiquidacionesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports